(function($)
{

    $.fn.builddialog = function(method, options) {
        // build main options before element iteration
        // Method calling logic
        var opts;
        if(methods[method])
        {
            opts = $.extend(true, {}, options);
        }
        else if(typeof method === 'object' || ! method)
        {
            opts = $.extend(true, {}, $.fn.builddialog.defaults, method);
        }
        else
        {
            $.error('Method ' + method + ' does not exist on jQuery.builddialog');
        }


        return this.each(function() {
             var $this = $(this);
             // build element specific options
             var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
             eOpts = $.fn.dataset ? $.extend(true, {}, eOpts, $this.dataset()) : eOpts;

             // Method calling logic
             if(methods[method])
             {
                 return methods[ method ].call(this, eOpts);
             } else if(typeof method === 'object' || ! method)
             {
                 return methods.init.call(this, eOpts);
             }
         });
    };
    //
    // Methods
    //
    var methods = {
        init : function(options) {
            options = $.extend({}, {'translateText': 'true'}, options);
            var $dialog = $(this);
            var toTranslate = options['translateText'];
            $dialog.append($('<div class="form"></div>'));
            $dialog.dialog($.extend({
                title :toTranslate ? translate(options['title']) : options['title'],
                autoOpen: false
            }, options.dialogOptions));
        },
        'form' : function(options) {
            options = $.extend( {}, {'translateText': 'true', 'orientation': 'vertical'}, options);
            var $dialog = $(this);
            var toTranslate = options['translateText'];
            $dialog.append($('<form class="form"></form>').attr('action', options['action']).attr('method', options['method']).addClass('orientation-' + options['orientation']).addClass(options['formClass']));
            $dialog.dialog($.extend({
                title :toTranslate ? translate(options['title']) : options['title'],
                autoOpen: false
            }, options.dialogOptions));
        },
        'textform' : function(options) {
            options = $.extend( {}, {'translateText': 'true', 'orientation': 'vertical'}, options);
            var $dialog = $(this);
            var toTranslate = options['translateText'];
            $dialog.append($('<div class="form"></div>').addClass('orientation-' + options['orientation']).addClass(options['formClass']));
            $dialog.dialog($.extend({
                title :toTranslate ? translate(options['title']) : options['title'],
                autoOpen: false,
                width : 'auto',
                height : 'auto',
                modal: true
            }, options.dialogOptions));
        },
        'textarea' : function(options) {
            var $dialog = $(this);
            var $input = $('<textarea cols="35" rows="6"></textarea>').attr('readonly', options['readonly']).attr('id', options['name']).attr('name', options['name']).addClass(options['inputClass']);
            if (options['height'])
            {
                $input.css('height', options['height']);
            }
            if(options['value']) {
                $input.text(options['value']);
            }
            var $inputDiv = $('<div class="form-textarea"></div>');
            var $row = createFormRow($inputDiv.append($input), options);
            $row.addClass('form-textarea-row');
            getDialogForm($dialog).append($row);
        },
        'text' : function(options) {
            var $dialog = $(this);
            var $input = $('<input type="text" />').attr('id', options['name']).attr('name', options['name']).addClass(options['inputClass']);
            if(options['value']) {
                $input.attr('value', options['value']);
            }
            var $inputDiv = $('<div class="form-input-text"></div>');
            var $row = createFormRow($inputDiv.append($input), options);
            $row.addClass('form-input-text-row');
            getDialogForm($dialog).append($row);
        },
        'password' : function(options) {
            var $dialog = $(this);
            var $input = $('<input type="password" />').attr('id', options['name']).attr('name', options['name']).addClass(options['inputClass']);
            var $inputDiv = $('<div class="form-input-text"></div>');
            var $row = createFormRow($inputDiv.append($input), options);
            $row.addClass('form-input-text-row');
            getDialogForm($dialog).append($row);
        },
        'file' : function(options) {
            var $dialog = $(this);
            var $input = $('<input type="file" />').attr('id', options['name']).attr('name', options['name']).addClass(options['inputClass']);
            var $inputDiv = $('<div class="form-input-file"></div>');
            var $row = createFormRow($inputDiv.append($input), options);
            $row.addClass('form-input-file-row');
            getDialogForm($dialog).append($row);
        },
        'radiobuttons' : function(options) {
            var $dialog = $(this);
            var toTranslate = options['translateText'];
            var $inputDiv = $('<div class="form-radiobuttons"></div>');

            var radioOptions = options['options'];
            for (var i = 0; i < radioOptions.length; i++) {
                var option = radioOptions[i];

                var $formRadio = $('<div class="form-radio" />');

                var id = options['name'] + '_' + i;

                var $input = $('<input type="radio" />').attr('id', id).attr('name', options['name']).attr('value', option.value);
                if(options['value'] == option.value) {
                    $input.attr('checked', 'checked');
                }
                $formRadio.append($input);

                var $label = $('<label />').attr('for', id).text(toTranslate?translate(option.name):option.name);
                $formRadio.append($label);

                $inputDiv.append($formRadio);
            }

            var $row = createFormRow($inputDiv, options);
            $row.addClass('form-radiobuttons-row');
            getDialogForm($dialog).append($row);
        },
        'row' : function(options) {
            var $dialog = $(this);
            var $row = createEmptyFormRow(options);
            getDialogForm($dialog).append($row);
        },
        'submit' : function(options) {
            var $dialog = $(this);
            var $button = $('<input type="submit" class="submit-button button" />').val(translate(options['text']));
            getDialogButtonRow($dialog).append('&nbsp;').append($button);
        },
        'button' : function(options) {
            options = $.extend({}, {'translateText': 'true'}, options);
            var $dialog = $(this);
            var toTranslate = options['translateText'];
            var $button = $('<button type="button" class="button" />').text(toTranslate?translate(options['text']):options['text']).addClass(options['buttonClass']);
            if(options['type']) {
                $button.attr('type', options['type']);
            }
            if(options['name']) {
                $button.attr('name', options['name']);
            }
            if(options['value']) {
                $button.attr('value', options['value']);
            }
            getDialogButtonRow($dialog).append('&nbsp;').append($button);
            $button.click(options['click']);
        },
        'message' : function(options) {
            options = $.extend({}, {'translateText': 'true'}, options);
            var $dialog = $(this);
            var toTranslate = options['translateText'];
            var $row = $('<p></p>').text(toTranslate?translate(options['text']):options['text']).addClass('message icon ui-state-highlight').attr('data-icon', 'ui-icon-info');
            if(options['bold']) {
                $row.wrapInner('<strong></strong>');
            }
            getDialogForm($dialog).append($row);
        },
        'warning' : function(options) {
            options = $.extend({}, {'translateText': 'true'}, options);
            var $dialog = $(this);
            var toTranslate = options['translateText'];
            var $row = $('<p></p>').text(toTranslate?translate(options['text']):options['text']).addClass('message icon ui-state-warn').attr('data-icon', 'ui-icon-alert');
            if(options['bold']) {
                $row.wrapInner('<strong></strong>');
            }
            getDialogForm($dialog).append($row);
        },
        'error' : function(options) {
            options = $.extend({}, {'translateText': 'true'}, options);
            var $dialog = $(this);
            var toTranslate = options['translateText'];
            var $row = $('<p></p>').text(toTranslate?translate(options['text']):options['text']).addClass('message icon ui-state-error').attr('data-icon', 'ui-icon-alert');
            if(options['bold']) {
                $row.wrapInner('<strong></strong>');
            }
            getDialogForm($dialog).append($row);
        },
        'custom' : function(options) {
            var $dialog = $(this);
            var $row = options['$row'];
            getDialogForm($dialog).append($row);
        },
        show : function(options) {
            var $dialog = $(this);
            // Attach all the required plugins...
            $dialog.msxiinit();
            $dialog.dialog('open');
            if(options['width']) {
                $dialog.dialog({width: options['width']});
            }
        },
        close : function(options) {
            var $dialog = $(this);
            $dialog.dialog('close');
        }
    };
    //
    // plugin defaults
    //
    $.fn.builddialog.defaults = {
        dialogOptions: $.fn.msxidialog.defaults.dialogOptions
    };
    //
    // Private functions
    //
    function getDialogForm($dialog)
    {
        if($dialog.find('.form').size()==0)
        {
            // If there is no form then create a textform
            $dialog.builddialog('textform');
        }
        return $dialog.find('.form');
    }
    function getDialogButtonRow($dialog)
    {
        var $dialogForm = getDialogForm($dialog);
        if($dialogForm.find('.button-row').size()==0)
        {
            // If there is no button row then create one
            var $row = $('<div class="button-row button-row-center"></div>');
            $dialogForm.append($row);
        }
        return $dialogForm.find('.button-row');
    }
    function createFormRow($inputDiv, options)
    {
        var $row = createEmptyFormRow(options);
        $row.append($inputDiv);
        return $row;
    }
    function createEmptyFormRow(options)
    {
        var $row = $('<div class="form-row"></div>');
        var $label = $('<label></label>').attr('for', options['name']);
        $label.html(translate(options['label']));
        if(options['required']) {
            $label.append($('<abbr class="required-star">*</abbr>').attr('title', translate('Required Field')));
        }
        $row.append($label);
        if (options['helper']) {
            $row.append(options['helper']);
        }
        return $row;
    }

})(jQuery);